import { Injectable, inject } from '@angular/core';
import { UserActions } from '@next/core-lib/user';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { AppState } from '../shared/models';
import * as SoilAnalysisActions from '../soil-analysis/store/soil-analysis.actions';

@Injectable()
export class AppEffects {
  protected store = inject<Store<AppState>>(Store);
  protected actions$ = inject(Actions);

  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      map(() => SoilAnalysisActions.loadDefaultSoilAnalyses()),
    ),
  );
}
